(function($) {
    var numSlick = 0;
    var $sliderFeatures = $('.slider-col-3');

    // Slider with 3 columns and arrows
    $sliderFeatures.each(function() {
        numSlick++;
        var sliderArrows = '.slider-arrows';

        $(this).addClass('slider-col-3-' + numSlick).slick({
            accessibility: false,
            appendArrows: $(this).closest('.slider-container').find(sliderArrows),
            arrows: true,
            slidesToScroll: 1,
            slidesToShow: 3,
            responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }]
        });
    })
    .on('setPosition', function (event, slick) {
        $(slick.$slides).height('auto').css('height', $(slick.$slideTrack).height() + 'px');
    });

})(jQuery);
